// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa {
  font-size: 30px;
  padding: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/routes/pages/icons/icons.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;AACF","sourcesContent":[".fa {\n  font-size: 30px;\n  padding: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
